// extracted by mini-css-extract-plugin
module.exports = {"boringstuff":"LegalLayouts_boringstuff__1PMSL","legal":"LegalLayouts_legal__1aPtD","title":"LegalLayouts_title__1wNZL"};